export default __webpack_public_path__ + "static/media/Logo.e2afe3b5.png";